export default "<div class=\"contentMain\">\r\n  dashboard works!\r\n</div>\r\n"